export default __webpack_public_path__ + "static/media/non-gmo-ingredients.dca5a0b9.svg";